'use client';

import { Badge, cn } from '@newfront-insurance/core-ui/v2';
import { DollarSign, Shield } from 'lucide-react';
import type { ComponentProps } from 'react';

import { getDataExplorerSourceMetadata, type SourceUrlPart } from '../chat-v2/lib/sources';

export type SourceBadgeProps = ComponentProps<'a'> & {
  source: SourceUrlPart;
  index: number;
  size?: 'sm' | 'default';
};

const ENTITY_TYPE_ICONS: Record<string, React.ComponentType<{ className?: string }>> = {
  policy: Shield,
  claim: DollarSign,
  invoice: DollarSign,
};

function getEntityTypeIcon(entityType: string): React.ComponentType<{ className?: string }> {
  return ENTITY_TYPE_ICONS[entityType.toLowerCase()] ?? Shield;
}

export function SourceBadge({ source, index, size = 'default', className, ...props }: SourceBadgeProps) {
  const dataExplorerMeta = getDataExplorerSourceMetadata(source);
  const Icon = dataExplorerMeta ? getEntityTypeIcon(dataExplorerMeta.entityType) : null;

  return (
    <a href={source.url} target="_blank" rel="noopener noreferrer" className={cn('no-underline', className)} {...props}>
      <Badge
        variant="secondary"
        className={cn(
          'hover:bg-secondary/80 cursor-pointer transition-colors',
          size === 'sm' && 'gap-1 px-2 py-0.5 text-xs font-normal',
        )}
      >
        {Icon && <Icon className="h-3 w-3" />}
        {index + 1}. {source.title}
      </Badge>
    </a>
  );
}
